import { sessionRevision } from "@/lib/session-request-scope";
import { useAuthUIStore } from "@/stores/auth-ui";

type AuthProvider = "google" | "apple";
type AuthIntent = "sign_in" | "link";
let pendingPopup: { window: Window; revision: number; intent: AuthIntent } | null = null;

export function consumeAuthPopup(
  event: MessageEvent,
): { intent: AuthIntent; revision: number } | null {
  if (!pendingPopup || event.source !== pendingPopup.window) {
    return null;
  }
  const { intent, revision } = pendingPopup;
  pendingPopup = null;
  return { intent, revision };
}

export function openAuthPopup(
  provider: AuthProvider,
  intent: AuthIntent = "sign_in",
  returnTo?: string,
): Window | null {
  const url = `/auth/${provider}?intent=${intent}`;
  const popup = window.open(url, "auth_popup", "width=500,height=700");
  pendingPopup = popup ? { window: popup, revision: sessionRevision(), intent } : null;

  if (!popup) {
    const destination =
      returnTo ??
      (intent === "sign_in"
        ? useAuthUIStore.getState().redirectAfterLogin || "/"
        : `${window.location.pathname}${window.location.search}`);
    const fallbackReturnTo = encodeURIComponent(destination);
    window.location.href = `${url}&return_to=${fallbackReturnTo}`;
  }

  return popup;
}
